import React from 'react'
import _ from 'lodash'
import { Icon, Button, Header, Form, Modal, Grid, TextArea, Checkbox } from 'semantic-ui-react'
import moment from 'moment'

import Input from '../common/input'


class CartBasedForm extends React.PureComponent {
  state = {
    restaurantOptions: []
  }

  btnSubmitRef = React.createRef()

  componentDidMount() {
    const { restaurants } = this.props
    const restaurantOptions = []

    _.map(restaurants, restaurant => {
      restaurantOptions.push({
        key: restaurant.key,
        value: restaurant.key,
        text: restaurant.name,
      })
    })

    this.setState({ restaurantOptions })
  }

  onSave = e => {
    const { onSaveCartBased } = this.props

    e.preventDefault()
    onSaveCartBased()
  }

  render() {
    const { restaurantOptions } = this.state
    const { visible, onClose, action, cartBasedData, onInputChange, loading } = this.props
    const {
      title,
      description,
      code,
      restaurant,
      active,
      discount,
      trigger_price: triggerPrice,
      target_price: targetPrice,
      auto_show: autoShow,
      expired_at: expiredAt,
      started_at: startedAt,
      is_global: isGlobal,
      redemption_failed_alert: redemptionFailedAlert,
    } = cartBasedData

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content="Add Cart Based" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form onSubmit={this.onSave} disabled={loading}>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Form.Field
                    required
                    control={Input}
                    value={title.en}
                    label="Title in English"
                    onChange={e => onInputChange('title', e.target.value, 'en')}
                  />
                  <Form.Field
                    required
                    control={Input}
                    value={title.kh}
                    label="Title in Khmer"
                    onChange={e => onInputChange('title', e.target.value, 'kh')}
                  />
                  <Form.Field
                    required
                    control={TextArea}
                    value={description.en}
                    label="Description in English"
                    onChange={e => onInputChange('description', e.target.value, 'en')}
                  />
                  <Form.Field
                    required
                    control={TextArea}
                    value={description.kh}
                    label="Description in Khmer"
                    onChange={e => onInputChange('description', e.target.value, 'kh')}
                  />
                  <Form.Field
                    required
                    control={Input}
                    value={triggerPrice}
                    label="Trigger Price"
                    onChange={e => onInputChange('trigger_price', e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    value={targetPrice}
                    label="Target Price"
                    onChange={e => onInputChange('target_price', e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    value={discount}
                    label="Discount Amount"
                    onChange={e => onInputChange('discount', e.target.value)}
                  />
                  <Form.Field required>
                    <label>Start From</label>
                    <input
                      type="date"
                      value={moment(parseInt(startedAt, 10)).format('YYYY-MM-DD')}
                      onChange={e => onInputChange('started_at', Number(
                        moment(e.target.value, 'YYYY-MM-DD')
                          .startOf('day')
                          .format('x')))
                      }
                    />
                  </Form.Field>
                  <Form.Field required>
                    <label>Expired At</label>
                    <input
                      type="date"
                      value={moment(parseInt(expiredAt, 10)).format('YYYY-MM-DD')}
                      onChange={e => onInputChange('expired_at',  Number(
                        moment(e.target.value, 'YYYY-MM-DD')
                          .endOf('day')
                          .format('x')))
                      }
                    />
                  </Form.Field>
                  {
                    !isGlobal && <Form.Field>
                      <Form.Select
                        search
                        required
                        fluid
                        label="Restaurant"
                        selection
                        value={restaurant}
                        onChange={(e, data) => onInputChange('restaurant', data.value)}
                        options={restaurantOptions}
                      />
                    </Form.Field>
                  }
                  <Form.Field
                    required
                    control={Input}
                    value={code}
                    label="Code"
                    onChange={e => onInputChange('code', e.target.value)}
                  />
                  <Form.Field>
                    <Checkbox
                      label='All Restaurants'
                      checked={isGlobal}
                      onChange={(e, { checked }) => onInputChange('is_global', checked)
                      }
                    />
                  </Form.Field>
                  <Form.Field>
                    <Checkbox
                      label='Active'
                      checked={active}
                      onChange={(e, { checked }) => onInputChange('active', checked)
                      }
                    />
                  </Form.Field>
                  <Form.Field>
                    <Checkbox
                      label='Auto In Store Pop-up'
                      checked={autoShow}
                      onChange={(e, { checked }) => onInputChange('auto_show', checked)}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Checkbox
                      label='Redemption Failed Alert'
                      checked={redemptionFailedAlert}
                      onChange={(e, { checked }) => onInputChange('redemption_failed_alert', checked)}
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> {action === 'create' ? 'Save' : 'Update'}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}


export default CartBasedForm



// WEBPACK FOOTER //
// ./src/components/cartBased/Form.js